import React from 'react';

const StripeOnboardingPage = React.lazy(() => import('./StripeOnboardingPage'));

const StripeOnboardingConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/billing/onboarding',
			element: (
				<React.Suspense fallback={<>...</>}>
					<StripeOnboardingPage />
				</React.Suspense>
			),
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default StripeOnboardingConfig;
